// packages/core/src/context/AppEventsContext.jsx
import React, { createContext, useContext, useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';

const AppEventsContext = createContext(null);

export const useAppEvents = () => {
  const context = useContext(AppEventsContext);
  if (!context) {
    throw new Error('useAppEvents must be used within an AppEventsProvider');
  }
  return context;
};

export const AppEventsProvider = ({ children }) => {
  const [handlers, setHandlers] = useState({});

  const registerAppEventHandler = useCallback((eventName, handler) => {
    // console.log(`[AppEvents] Registering handler for event: ${eventName}`);
    setHandlers(prev => ({ ...prev, [eventName]: handler }));
  }, []);

  const unregisterAppEventHandler = useCallback((eventName) => {
    // console.log(`[AppEvents] Unregistering handler for event: ${eventName}`);
    setHandlers(prev => {
      const newHandlers = { ...prev };
      delete newHandlers[eventName];
      return newHandlers;
    });
  }, []);

  const contextValue = useMemo(() => ({
    handlers,
    registerAppEventHandler,
    unregisterAppEventHandler,
  }), [handlers, registerAppEventHandler, unregisterAppEventHandler]);

  return (
    <AppEventsContext.Provider value={contextValue}>
      {children}
    </AppEventsContext.Provider>
  );
};

AppEventsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};